import { createAction } from 'redux-actions';
import { ApiException } from '@eta/components';
import {
    LOAD_CURRENT_INVITATION,
    COMPLETE_PROFILE,
    ACCEPT_INVITATION,
} from './Types';
import {
    CreateUserProfileDto,
    AccetpInvitationDto,
} from '../../Services/ClientProxy/clientProxy';
import { ServiceCreator } from '../../Services/ClientProxy/ServiceFactory';

const invitationServiceAnonymous = ServiceCreator.getTaxPayerProfileManagementClient(true);
// TypeScript infers that this function is returning SendMessageAction

export const loadCurrentInvitation = createAction(
    LOAD_CURRENT_INVITATION,
    async (invitationId: string) => {
        try {
            return await invitationServiceAnonymous.checkDelegationInvitationIsExist(invitationId);
        } catch (ex) {
            
            const apiException = ex as ApiException;
            return { lastError: apiException };
        }
    }
);

export const completeProfile = createAction(
    COMPLETE_PROFILE,
    async (profile: CreateUserProfileDto) => {
        try {
            await invitationServiceAnonymous.completeUserProfile(profile);
        } catch (ex) {
            const apiException = ex as ApiException;
            return { lastError: apiException, profile };
        }
        return { lastError: null, profile };
    }
);

export const acceptInvitation = createAction(
    ACCEPT_INVITATION,
    async (invitationID: string, invitation: AccetpInvitationDto) => {
        try {
            await invitationServiceAnonymous.acceptInvitation(invitationID, invitation);
        } catch (ex) {
            const apiException = ex as ApiException;
            return { lastError: apiException, invitation };
        }
        return { lastError: null, invitation };
    }
);
